import axios from "axios";
import { API_BASE_URL } from "../config/apiBase";

function getAdminToken() {
  return localStorage.getItem("accessToken") || "";
}

/**
 * Upload a CMS image to S3 via presigned URL (admin JWT, purpose: cms).
 * Returns the CloudFront/public URL to save in site CMS APIs.
 */
export async function uploadCmsImageToS3(file, baseUrl = API_BASE_URL) {
  if (!file) {
    throw new Error("No file selected");
  }

  const token = getAdminToken();
  if (!token) {
    throw new Error("Admin session expired. Please sign in again.");
  }

  const isPdf = file.type === "application/pdf";
  const contentType = isPdf ? "application/pdf" : file.type || "image/jpeg";
  const extension = isPdf
    ? "pdf"
    : contentType.includes("png")
      ? "png"
      : contentType.includes("webp")
        ? "webp"
        : "jpg";

  const signRes = await axios.post(
    `${baseUrl}/uploads/sign`,
    { purpose: "cms", contentType, extension },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  const data = signRes.data?.data;
  if (!data?.uploadUrl || !data?.publicUrl) {
    throw new Error(signRes.data?.message || "Failed to get upload URL");
  }

  await axios.put(data.uploadUrl, file, {
    headers: { "Content-Type": data.contentType || contentType },
    maxBodyLength: Infinity,
    maxContentLength: Infinity,
  });

  return data.publicUrl;
}
